import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import "./icon.scss";
import { useI18n } from "i18n";

interface IProps {
  needFrame?: boolean;
  value?: string;
}

const SansanIcon = ({ needFrame = true, value }: IProps) => {
  const activeClass = value ? "active" : "";
  const { t } = useI18n(["eventForm"]);

  return (
    <Tooltip title={t("eventForm:sansan.profile") as string} arrow>
      <a
        href={value}
        rel="noopener noreferrer"
        target="_blank"
        className={`${needFrame ? "frame" : ""} ${activeClass}`}
      >
        <svg
          fill="white"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="39.632px"
          height="33.233px"
          viewBox="-9 3 60 25"
        >
          <path
            className="a"
            d="M30.462,18.622c-3.3,0.07-6.02-2.7-6.08-6.18c-0.06-3.48,2.56-6.36,5.85-6.42c3.3-0.07,6.02,2.7,6.08,6.18
              C36.372,15.682,33.752,18.562,30.462,18.622z M11.762,23.982c-3.29,0.07-6.01-2.7-6.07-6.18c-0.06-3.48,2.56-6.36,5.85-6.43
              c3.29-0.06,6.01,2.71,6.07,6.19C17.682,21.042,15.062,23.922,11.762,23.982z M30.132,0.002c-5.06,0.1-9.3,3.6-10.83,8.39
              c-2.1-1.94-4.86-3.09-7.87-3.02c-6.43,0.12-11.55,5.74-11.43,12.54c0.12,6.8,5.44,12.22,11.87,12.09c5.06-0.1,9.3-3.6,10.83-8.39
              c2.1,1.94,4.86,3.08,7.87,3.02c6.43-0.12,11.55-5.74,11.43-12.54C41.882,5.292,36.562-0.128,30.132,0.002z"
          />
        </svg>
      </a>
    </Tooltip>
  );
};

export default SansanIcon;
